module.exports = __webpack_public_path__ + "static/vlog_cover_en-da4cf49c68adbf5956d4c1b187759a7d.png";